// ValuesSection.jsx
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FiHeart, FiUsers, FiMessageCircle, FiShield } from 'react-icons/fi';
import '../../../../assets/css/customer/subscreens/about/ValuesSection.css';

const ValuesSection = () => {
  const values = [
    {
      id: 1,
      icon: <FiHeart />,
      title: 'Handmade with Love',
      description: 'Every product is crafted with passion and dedication by talented artisans.'
    },
    {
      id: 2,
      icon: <FiUsers />,
      title: 'Community First',
      description: 'We empower local artisans and support their creative businesses across Pakistan.'
    },
    {
      id: 3,
      icon: <FiMessageCircle />,
      title: 'Made Just for You',
      description: 'Chat directly with sellers to customize your order exactly the way you want it.'
    },
    {
      id: 4,
      icon: <FiShield />,
      title: 'Safe & Simple',
      description: 'Shop with confidence — pay easily with Cash on Delivery, no hassle.'
    }
  ];

  return (
    <section className="values-section">
      <Container>
        <h2 className="section-title-center">Our Values</h2>
        <p className="section-subtitle-center">
          The principles that guide everything we do
        </p>

        <Row className="values-grid">
          {values.map((value) => (
            <Col lg={3} md={6} sm={12} key={value.id}>
              <div className="value-card">
                <div className="value-icon-wrapper">
                  <div className="value-icon">{value.icon}</div>
                </div>
                <h3 className="value-title">{value.title}</h3>
                <p className="value-description">{value.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default ValuesSection;